export var UIClientTypes = {
  application: 'application',
  dashboard: 'dashboard',
  mobile: 'mobile'
};